import bitcoin from '../../assets/bitcoin.svg';
import ethereum from '../../assets/ethereum.svg';
import litecoin from '../../assets/litecoin.svg';

const ItemsArray = [
  {
    subtitle: 'BTC',
    title: 'Bitcoin',
    icon: bitcoin,
    description:
      'Digital currency in which a record of transactions is maintained.'
  },
  {
    subtitle: 'ETH',
    title: 'Ethereum',
    icon: ethereum,
    description:
      'Blockchain technology to create and run decentralized digital applications.'
  },
  {
    subtitle: 'LTC',
    title: 'Litecoin',
    icon: litecoin,
    description:
      'Cryptocurrency that enables instant payments to anyone in the world.'
  }
];

export default ItemsArray